import { ChevronLeft, ChevronRight, MoreHorizontal } from "lucide-react";
import "./Pagination.css";

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  pageRangeDisplayed = 3,
  marginPagesDisplayed = 2,
  className = "pagination",
  activeClassName = "active",
}) => {
  const handlePageChange = (page) => {
    if (page >= 0 && page < totalPages) {
      onPageChange({ selected: page });
    }
  };

  const getPageNumbers = () => {
    const pages = [];
    const totalPagesNum = totalPages;
    const current = currentPage;

    if (totalPagesNum <= pageRangeDisplayed + 2 * marginPagesDisplayed) {
      for (let i = 0; i < totalPagesNum; i++) {
        pages.push(i);
      }
    } else {
      let leftSide = pageRangeDisplayed / 2;
      let rightSide = pageRangeDisplayed - leftSide;

      if (current > totalPagesNum - pageRangeDisplayed / 2 - 1) {
        rightSide = pageRangeDisplayed - 1;
        leftSide = 0;
      } else if (current < pageRangeDisplayed / 2) {
        leftSide = 0;
        rightSide = pageRangeDisplayed - 1;
      }

      for (let i = 0; i < totalPagesNum; i++) {
        if (i < marginPagesDisplayed || i >= totalPagesNum - marginPagesDisplayed || (i >= current - leftSide && i <= current + rightSide)) {
          pages.push(i);
        } else if (pages[pages.length - 1] !== -1) {
          pages.push(-1);
        }
      }
    }

    return pages;
  };

  const pages = getPageNumbers();

  return (
    <ul className={className}>
      <li className="page-item">
        <button
          className="page-link"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 0}
        >
          <ChevronLeft size={20} />
        </button>
      </li>

      {pages.map((page, index) =>
        page === -1 ? (
          <li key={`ellipsis-${index}`} className="page-item">
            <span className="page-link">
              <MoreHorizontal size={20} />
            </span>
          </li>
        ) : (
          <li key={page} className={`page-item ${page === currentPage ? activeClassName : ""}`}>
            <button
              className="page-link"
              onClick={() => handlePageChange(page)}
            >
              {page + 1}
            </button>
          </li>
        )
      )}

      <li className="page-item">
        <button
          className="page-link"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages - 1}
        >
          <ChevronRight size={20} />
        </button>
      </li>
    </ul>
  );
};

export default Pagination;